var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.disabled && !_vm.readonly)?_c('el-slider',{attrs:{"marks":_vm.marks,"size":_vm.size,"value":_vm.value,"min":_vm.min,"max":_vm.max,"range":_vm.range},on:{"input":_vm.change}}):_c('el-input',{attrs:{"size":_vm.size,"value":_vm.value,"readonly":_vm.readonly,"disabled":_vm.disabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }